/* eslint-disable dot-notation */
import React, { useContext } from 'react';
import Table from 'react-bootstrap/Table';
import { useTranslation } from 'react-i18next';

import {
  Ctx,
  Check,
  Text,
} from 'containers/Forms/Settings/components/CtxInputs';
import { returnTenders } from 'containers/Forms/Settings/views/Payment/components/tenders';

const ReturnWithoutReceipt = ({ prefix }) => {
  const { values } = useContext(Ctx);
  const { t } = useTranslation('settingsPayment');
  return (
    <Table>
      <thead>
        <tr>
          <th>{t('common.type')}</th>
          <th style={{ width: '150px' }}>{t('common.limit')}</th>
        </tr>
      </thead>
      <tbody>
        {returnTenders.map(({ transKey, configName }) => (
          <tr key={`${prefix}_${transKey}_${configName}`}>
            <td style={{ verticalAlign: 'inherit' }}>
              <Check
                title={t(`${prefix}.tenders.${transKey}`)}
                name={`pos_allow_return_${configName}`}
                disabled={values['pos_allow_return_original_tender_only']}
              />
            </td>
            <td colSpan={2}>
              <Text
                title=""
                name={`pos_allow_return_${configName}_limit`}
                disabled={
                  !values[`pos_allow_return_${configName}`] ||
                  values['pos_allow_return_original_tender_only']
                }
              />
            </td>
          </tr>
        ))}
      </tbody>
    </Table>
  );
};

export default ReturnWithoutReceipt;
